import { render, staticRenderFns } from "./ManageAlertCodeBody.vue?vue&type=template&id=1a0afaa3&"
import script from "./ManageAlertCodeBody.vue?vue&type=script&lang=js&"
export * from "./ManageAlertCodeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports